// extracted by mini-css-extract-plugin
export var formContainer = "_di-0";
export var message = "_di-1";